import UserMarks from './UserMarks';

export default UserMarks;
